import { getDataFromServer, dict2urlEncode } from '../http_utils.js'

export function fetchMenu() {
    var request_data = {
        "service": "menu",
        "operation": "get_doday_menu",
        "store_id": "DDA",
        "menu_name": "全日菜單"
    }

    var request_str = dict2urlEncode(request_data)
    return getDataFromServer(process.env.REACT_APP_SERVER_URL + '?' + request_str).then(result => {
        if (result["indicator"]) {
            var temp_dict = {}
            var cat_key = ""
            var item_key = ""
            for (var i = 0; i < Object.keys(result["message"]["category"]).length; i++) {
                cat_key = Object.keys(result["message"]["category"])[i]
                temp_dict[cat_key] = []
                for (var j = 0; j < Object.keys(result["message"]["category"][cat_key]).length; j++) {
                    item_key = Object.keys(result["message"]["category"][cat_key])[j]
                    if (item_key.indexOf('額外補差價') !== -1) continue;
                    temp_dict[cat_key].push({
                        "name": item_key,
                        "more_info": result["message"]["category"][cat_key][item_key]
                    })
                }
            }
            return {
                cat_list: Object.keys(result["message"]["category"]),
                menu_dict: temp_dict
            }
        }
        return { cat_list: [], menu_dict: {} }
    })
}
